<template>
    <v-chip v-if="subscription.status === 'active' && subscription.cancelAtPeriodEnd === true" variant="flat" color="orange"
        >Active until {{ formatDate(subscription.currentPeriodEndDate) }}</v-chip
    >
    <v-chip v-else-if="subscription.status === 'active'" variant="flat" color="green">Active</v-chip>
    <v-chip v-else-if="subscription.status === 'trialing'" variant="flat" color="green">Active - Trialing</v-chip>
    <v-chip v-else variant="flat">{{ subscription.status }}</v-chip>
</template>

<script lang="ts" setup>
import { formatDate } from '@/lib/utils'
import type { SubscriptionV1 } from '@geckoal/gecko-api-client'
import { type PropType } from 'vue'

defineProps({
    subscription: {
        type: Object as PropType<SubscriptionV1>,
        required: true
    }
})
</script>
